import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationAuto"><Path d="M20.5 3.5C10.9375 3.50003 12 20.5 3.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationAuto;
